import { Button } from '@/components/ui/button';
import { Plus, Minus } from 'lucide-react';

export function ProductQuantity({ quantity, setQuantity }) {
  return (
    <div>
      <p className="text-sm uppercase tracking-widest font-bold mb-4">QUANTITY</p>
      <div className="flex items-center space-x-4">
        <Button
          onClick={() => setQuantity(Math.max(1, quantity - 1))}
          data-testid="decrease-quantity"
          variant="outline"
          size="icon"
          className="rounded-none w-12 h-12"
        >
          <Minus className="w-4 h-4" />
        </Button>
        <span className="mono text-2xl font-bold w-16 text-center" data-testid="quantity-display">
          {quantity}
        </span>
        <Button
          onClick={() => setQuantity(quantity + 1)}
          data-testid="increase-quantity"
          variant="outline"
          size="icon"
          className="rounded-none w-12 h-12"
        >
          <Plus className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
